import { createContext } from 'react';
import ToggleHeaderContext from 'types/contexts/ToggleHeaderContext';

export default createContext({} as ToggleHeaderContext);
